import api from './api';

const lookupService = {
  getIcdCodes: async () => {
    const response = await api.get('/lookup/icd-codes');
    return response.data;
  },
  searchIcdCodes: async (q) => {
    const response = await api.get('/lookup/icd-codes/search', { params: { q } });
    return response.data;
  },
};

export default lookupService;
